import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ChevronRight, Inbox } from "lucide-react";
import { api } from "@/lib/api";
import { LevelBadge } from "@/components/LevelBadge";
import { ThemeIcon } from "@/components/ThemeIcon";
import { Skeleton } from "@/components/ui/skeleton";

const fmt = (d) => new Date(d + "T12:00:00").toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" });

export default function HistoryPage() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/lessons/history").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-5">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase">Mes leçons</h1>
      {!items ? (
        <Skeleton className="h-20 w-full" />
      ) : items.length === 0 ? (
        <div className="bg-white rounded-2xl border-2 border-dashed border-slate-300 p-8 text-center text-slate-600" data-testid="history-empty">
          <Inbox className="w-10 h-10 mx-auto mb-2 text-slate-400" />
          Aucune leçon terminée pour le moment.
        </div>
      ) : (
        <div className="space-y-3" data-testid="history-list">
          {items.map((l, i) => (
            <Link
              key={l.id}
              to={`/lecon/${l.id}`}
              data-testid={`history-item-${l.id}`}
              className={`rise rise-${Math.min(i, 3)} flex items-center gap-4 bg-white rounded-2xl border-2 border-slate-200 hover:border-orange-500 p-4 transition-colors`}
            >
              <div className="shrink-0 w-12 h-12 rounded-xl bg-slate-900 text-amber-400 grid place-items-center">
                <ThemeIcon theme={l.theme} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-xs font-bold uppercase text-slate-500">{fmt(l.date)}</div>
                <div className="font-bold truncate">{l.title}</div>
                <div className="mt-1"><LevelBadge level={l.level} /></div>
              </div>
              <div className="text-right">
                <div className="flex items-center gap-1 font-display text-2xl font-bold text-emerald-700">
                  <CheckCircle2 className="w-5 h-5" /> {l.score}/{l.total}
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-slate-400" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
